/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Shell_Pick_TagInputs */

const en_auth_shell_pick_tag = /** @type {(inputs: Auth_Shell_Pick_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your pick`)
};

const pl_auth_shell_pick_tag = /** @type {(inputs: Auth_Shell_Pick_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój wybór`)
};

/**
* | output |
* | --- |
* | "Your pick" |
*
* @param {Auth_Shell_Pick_TagInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_shell_pick_tag = /** @type {((inputs?: Auth_Shell_Pick_TagInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Shell_Pick_TagInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_shell_pick_tag(inputs)
	return en_auth_shell_pick_tag(inputs)
});